var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtilisationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9495 13.1833L14.8329 14.85L20.1329 5.7L23.8829 12.1833L19.5495 14.6833L28.6495 17.1167L31.0995 8.01666L26.7662 10.5167L23.0162 4.01667C22.7987 3.63667 22.508 3.30352 22.161 3.03643C21.8141 2.76933 21.4177 2.57358 20.9947 2.46047C20.5717 2.34736 20.1305 2.31913 19.6965 2.3774C19.2625 2.43568 18.8444 2.57931 18.4662 2.8C18.0162 3.05 17.6329 3.41667 17.3495 3.85M16.6662 33.3333V30H6.09954L9.83288 23.5L14.1662 26L11.7329 16.9L2.61621 19.3333L6.94954 21.8333L3.19954 28.3333C2.91512 28.8267 2.76166 29.3847 2.75375 29.9541C2.74583 30.5236 2.88374 31.0856 3.15434 31.5867C3.42494 32.0879 3.81925 32.5114 4.29975 32.8171C4.78025 33.1228 5.33098 33.3005 5.89954 33.3333M31.7662 19.1667L28.8662 20.8333L34.1662 30H26.6662V25L19.9995 31.6667L26.6662 38.3333V33.3333H34.1662C36.0162 33.3333 37.4995 31.85 37.4995 30C37.4995 29.4833 37.3662 28.9667 37.1329 28.5167L31.7662 19.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilisationWhite);
export default __webpack_public_path__ + "static/media/utilisation-white.75df25b63f76bcdac5350f943b7e156e.svg";
export { ForwardRef as ReactComponent };